import React, {useMemo} from "react";
import styled from "styled-components";
import {useInventory} from "../State/InventoryContext";
import {pollutionRatio, POLLUTION_LIMIT} from "../State/Pollution";

const MeterWrapper = styled.div`
  position: fixed;
  top: 12px;
  right: 12px;
  width: 240px;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid #d8d8d8;
  border-radius: 10px;
  padding: 10px 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  pointer-events: none;
  z-index: 10;
`;

const LabelRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: #333;
  margin-bottom: 6px;
`;

const BarTrack = styled.div`
  width: 100%;
  height: 10px;
  background: #f0f0f0;
  border-radius: 6px;
  overflow: hidden;
`;

const BarFill = styled.div<{ $ratio: number }>`
  width: ${({$ratio}) => `${Math.min(100, Math.max(0, $ratio * 100))}%`};
  height: 100%;
  background: linear-gradient(90deg, #2ecc71 0%, #f1c40f 50%, #e74c3c 100%);
  transition: width 0.3s ease;
`;

export function PollutionMeter() {
  const {pollution} = useInventory();
  const ratio = useMemo(() => pollutionRatio(pollution), [pollution]);

  return (
    <MeterWrapper>
      <LabelRow>
        <span>Pollution</span>
        <span>{Math.round(pollution)} / {POLLUTION_LIMIT}</span>
      </LabelRow>
      <BarTrack>
        <BarFill $ratio={ratio} />
      </BarTrack>
    </MeterWrapper>
  );
}
